module.exports = __webpack_public_path__ + "media/images/countrysquared/mt-a9fbd0bfb2173874c6da09eaed5ce8b4.svg";